import { IconButton as BaseIconButton } from '@mui/material';
import React from 'react';

function LegacyIconButton({ variant = 'default', sx, ...props }) {
  return (
    <BaseIconButton
      {...props}
      sx={{
        backgroundColor: variant === 'transparent' ? 'unset' : undefined,
        ...sx,
      }}
    />
  );
}

export default LegacyIconButton;
